/* eslint-disable no-console */
import { defineStore } from 'pinia';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import * as firestoreSenhaTotemActions from './firestore/senhaTotemActions'
import { useSenhaStore } from '../senha';

export const useFirebaseStore = defineStore('firebase', {
    //https://stackoverflow.com/questions/53179341/where-to-initialize-firebase-in-vue-js-app
    state: () => ({
        app: null,
        db: null,
        rtSenha: null,
    }),

    getters: {
    },

    actions: {
        async initFirebaseApp(config) {
            if (!this.app) {
                this.app = initializeApp(config)
                this.db = getFirestore(this.app);
            }

            const senhaStore = useSenhaStore()
            senhaStore.startSenhaTotemRealTime()
        },

        //Pedido Loja actions
        ...firestoreSenhaTotemActions,
    }
})
/* eslint-enable no-console */